import axios from 'axios'
import { CADASTRAR_RESERVA, VERIFICAR_PAGAMENTO, PAGAR_FORMA_PAGAMENTO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export function cadastrarReserva (crirReserva) {
  const url = `${URL}/reserva/cadastrar/terminal-venda`;
  return dispatch => axios.post(url, crirReserva, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_RESERVA,
        payload: response
      })
  );
}

export function pagarPedido(crirReserva) {
    const url = `${URL}/reserva/cadastrar/terminal-venda-tef`;
    return dispatch => axios.post(url, crirReserva, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_RESERVA,
            payload: response
        })
    );
}

export function pagarFormaPagamentoPedido(idFormaPagamento, idEmpresa) {
    const url = `${URL}/reserva/empresa/${idEmpresa}/pagar-forma-pagamento/${idFormaPagamento}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: PAGAR_FORMA_PAGAMENTO,
            payload: response
        })
    );
}

export function verificarPagamento(idPedido, formaPagamento) {
    const url = `${URL}/reserva/pedido/${idPedido}/forma-pagamento/${formaPagamento}/status`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: VERIFICAR_PAGAMENTO,
            payload: response
        })
    );
}

